module.exports = __webpack_public_path__ + "img/logo_people_master.82855733.svg";